import { KeyValPair } from '@models/common.model'
import { Box, Checkbox, Chip, InputAdornment, MenuItem, OutlinedInput, Select, SelectChangeEvent, Typography,  } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import { useState } from 'react'

const DialogSearch = ({ 
    options,
    placeholder,
	handleSearchRolesByProject
}: { 
    options: KeyValPair[]
    placeholder?: string
	handleSearchRolesByProject: any
}) => {
	const [projectsNameToBeSearched, setProjectsNameToBeSearched] = useState<any[]>([]);

	const handleChangeProjectsName = (event:any, _2:any) => {
		const { target: { value } } = event;
		if(projectsNameToBeSearched.length < 5){
			setProjectsNameToBeSearched(typeof value === 'string' ? value.split(',') : value)
		}else if((projectsNameToBeSearched.length === 5) && (_2?.props?.children[0]?.props?.checked)){
			setProjectsNameToBeSearched(typeof value === 'string' ? value.split(',') : value)
		}
		
	}

	const checkIsSelected = (projectName:string) => {
		return projectsNameToBeSearched.indexOf(projectName) > -1
	}

	const handleClick = () => {
		const projectIdList = [];
		for(let i = 0; i < options.length; i++){
			for(let j = 0; j < projectsNameToBeSearched.length; j++){
				if(options[i].value === projectsNameToBeSearched[j]){
					projectIdList.push(options[i].key)
				}
			}
			
		}
		handleSearchRolesByProject(projectIdList)
	}

	return (
		<Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', }}>
			<Select
				displayEmpty
				sx={{width: '100%'}}
				disableUnderline
				id={"select-project"}
				multiple
				variant="standard"
				MenuProps={{
					anchorOrigin: {
						vertical: 'bottom',
						horizontal: 'left',
					},
					transformOrigin: {
						vertical: 'top',
						horizontal: 'left',
					},
					keepMounted: true,
				}}
				value={projectsNameToBeSearched}
				onChange={(_, _2)=>{
					handleChangeProjectsName(_, _2)
				}}
				renderValue={(selected)=>{
					return (
						selected?.length === 0 ? 
							<Box sx={{color: 'grey'}}>Please select projects</Box> 
							:
							<Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
								{selected.map((value) => (
									<Chip key={value} label={value} />
								))}
							</Box>
							
						)
				}}
				// renderValue={(selected)=>{
				// 	if (selected.length === 0) {
				// 		return placeholder;
				// 	}else{
				// 		return <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
				// 			{
				// 				selected?.map((value:any, index:number)=>{
				// 					console.debug(value)
				// 					return <Chip key={value} label={value} />
				// 				})
				// 			}
				// 		</Box>
						
				// 	}
				// }}
				// inputProps={{
				// 	startAdornment: <InputAdornment position="start" onClick={()=>{}}>
				// 			<SearchIcon color="info" fontSize={"large"} />
				// 		</InputAdornment>
				// }}
			>
				<MenuItem disabled value="">
					<em>Please select not more than 5 projects</em>
				</MenuItem>
				{options?.map((elem: any, index: number) => {
					return (
						<MenuItem key={elem.key} value={elem.value}>
							{/* <Checkbox checked={projectsNameToBeSearched?.indexOf(elem.value) > -1}/> */}
							<Checkbox checked={checkIsSelected(elem.value)}/>
							<Typography variant="body2">{elem.value}</Typography>
						</MenuItem>
					)
				})}
			</Select>
			<SearchIcon color="info" fontSize={"large"} onClick={handleClick} sx={{cursor: "pointer"}}/>
		</Box>
		
	)
}

export default DialogSearch
